import { QueryClient } from '@tanstack/react-query';

import { consultationDetailsKeys } from '../model/consts';

export const invalidateConsultationDetails = (
    queryClient: QueryClient,
    consultationUid: string,
) => {
    if (!queryClient) return;
    consultationDetailsKeys.forEach((key) => {
        queryClient.invalidateQueries({ queryKey: [key, consultationUid] });
    });
};
